/**
 * `media` — fichiers d'image et leurs variantes (base galerie, 4.1).
 */
import { z } from 'zod';
import { bilingueSchema, CHAMPS_DOCUMENT, idSchema, withAudit } from './commun.js';
/** Ce que l'image montre. */
export const TYPES_MEDIA = ['vue', 'detail', 'verso', 'accrochage', 'portrait'];
export const typeMediaSchema = z.enum(TYPES_MEDIA);
/** À quoi l'image est rattachée. */
export const CIBLES_MEDIA = ['artwork', 'exhibition', 'artist', 'post', 'movement'];
export const cibleMediaSchema = z.enum(CIBLES_MEDIA);
/** Une variante produite par `sharp` (D15). */
export const varianteMediaSchema = z.object({
    cle: z.string(),
    largeur: z.int().min(1),
    hauteur: z.int().min(1),
    octets: z.int().min(0),
    format: z.enum(['avif', 'webp', 'jpeg']),
});
export const mediaSchema = withAudit(z.object({
    _id: idSchema,
    cleOriginale: z.string().min(1),
    octets: z.int().min(0),
    largeur: z.int().min(1),
    hauteur: z.int().min(1),
    variantes: z.array(varianteMediaSchema).default([]),
    type: typeMediaSchema.default('vue'),
    rattachement: z.object({ type: cibleMediaSchema, id: idSchema }),
    credit: z.string().optional(),
    legende: bilingueSchema.optional(),
    ordre: z.int().min(0).default(0),
}));
export const mediaCreationSchema = mediaSchema.omit({ ...CHAMPS_DOCUMENT, variantes: true });
export const mediaMiseAJourSchema = mediaCreationSchema
    .omit({ cleOriginale: true, octets: true, largeur: true, hauteur: true })
    .partial();
//# sourceMappingURL=media.js.map